import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    ModuleNamePipe,
    NameByIdPipe,
    FullNamePipe,
} from './module-name.pipe';
import {
    ActiveUserPipe,
    ColumnTemplatePipe,
    PersonPipe,
    FormControlPipe,
    UserPipe,
} from './common.pipe';

@NgModule({
    imports: [
    ],
    declarations: [
        ModuleNamePipe,
        NameByIdPipe,
        PersonPipe,
        FullNamePipe,
        ActiveUserPipe,
        ColumnTemplatePipe,
        FormControlPipe,
        UserPipe,
    ],
    exports: [
        ModuleNamePipe,
        NameByIdPipe,
        PersonPipe,
        FullNamePipe,
        ActiveUserPipe,
        ColumnTemplatePipe,
        FormControlPipe,
        UserPipe,
    ],
    providers: [
    ]

})
export class PipesModule { }
